import { render, staticRenderFns } from "./ActionTransaction.vue?vue&type=template&id=0142d584"
import script from "./ActionTransaction.vue?vue&type=script&lang=js"
export * from "./ActionTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports